import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Swal from "sweetalert2";
import frymesOrderApi from "../../api/frymeOrderApi";
import Pagination from "../../components/Pagination";

const RejectedRequests = () => {
  const [rejectedRequests, setRejectedRequests] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");

  useEffect(() => {
    fetchRejectedRequests();
  }, [page, pageSize, sortedColumn, sortOrder]);

  const fetchRejectedRequests = async () => {
    try {
      const response = await frymesOrderApi.getRequestOfMA(
        "REJECTED",
        page,
        pageSize,
        sortedColumn,
        sortOrder,
      );

      setRejectedRequests(response?.data?.content || []);
      setTotalPages(response?.data?.totalPages || 0);
    } catch (error) {
      console.error("Error fetching rejected requests:", error);
      setRejectedRequests([]);
      setTotalPages(0);
    }
  };

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value, 10);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1));

    setPage(selectedPage);
    localStorage.setItem("userCreditListAdmin", selectedPage);
  };

  const handleApprove = async (request) => {
    try {
      await frymesOrderApi.approveRequest(request.id);

      Swal.fire({
        icon: "success",
        title: "Approved!",
        text: "Request approved successfully",
        timer: 2000,
        showConfirmButton: false,
      });

      // Remove approved item from table immediately
      setRejectedRequests((prev) =>
        prev.filter((item) => item.id !== request.id),
      );

      // Optional: refresh from backend again
      fetchRejectedRequests();
    } catch (error) {
      console.error("Approve Error:", error);

      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "Failed to approve request",
      });
    }
  };

  const handleReject = async (request) => {
    try {
      await frymesOrderApi.rejectRequest(request.id);

      Swal.fire({
        icon: "success",
        title: "Rejected!",
        text: "Request rejected successfully",
        timer: 2000,
        showConfirmButton: false,
      });

      // Remove rejected item from table immediately
      setRejectedRequests((prev) =>
        prev.filter((item) => item.id !== request.id),
      );

      // Optional: refresh from backend again
      fetchRejectedRequests();
    } catch (error) {
      console.error("Reject Error:", error);

      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "Failed to reject request",
      });
    }
  };
  return (
    <>
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>Buyer Details</th>
            <th>Quantity</th>
            <th>Unit Price</th>
            <th>Total Amount</th>
            <th>updated At</th>
          </tr>
        </thead>

        <tbody>
          {rejectedRequests.length > 0 ? (
            rejectedRequests.map((pricing, index) => (
              <tr key={pricing.id || index}>
                <td>{page * pageSize + index + 1}</td>

                {/* BUYER DETAILS */}
                <td>
                  {pricing.buyer ? (
                    <>
                      <strong>Franchise</strong>
                      <br />
                      <small>{pricing.buyer?.organization || "-"}</small>
                      <br />
                      <small>{pricing.buyer?.location || "-"}</small>
                      <br />
                      <small>{pricing.buyer?.email || "-"}</small>
                    </>
                  ) : (
                    <>
                      <strong>Customer</strong>
                      <br />
                      <small>{pricing.customerName || "Customer"}</small>
                      <br />

                      {/* Show company details if available */}
                      {pricing.companyDetails ? (
                        <>
                          <small>
                            {pricing.companyDetails?.companyName || "-"}
                          </small>
                          <br />
                          <small>
                            {pricing.companyDetails?.location || "-"}
                          </small>
                        </>
                      ) : (
                        <small>{pricing.customerEmail || "-"}</small>
                      )}
                    </>
                  )}
                </td>

                <td>{pricing.quantity || "-"}</td>

                <td>
                  {pricing.unitPrice} {pricing.currencySymbol} (
                  {pricing.currencyCode})
                </td>

                <td>
                  {pricing.totalAmount} {pricing.currencySymbol} (
                  {pricing.currencyCode})
                </td>

                <td>{pricing.updatedAt || "-"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center">
                No Rejected Requests Found
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <div style={{ marginTop: "auto" }}>
        {rejectedRequests.length > 0 && totalPages > 0 && (
          <Pagination
            page={page}
            pageSize={pageSize}
            totalPages={totalPages}
            handlePageSizeChange={handlePageSizeChange}
            handlePageClick={handlePageClick}
          />
        )}
      </div>
    </>
  );
};
export default RejectedRequests;
